import React from "react";
import FinancialProductType from "../FinancialProductType";
import NajLeasingInstallmentCalculator from "./NajLeasingInstallmentCalculator";
import RentalInstallmentCalculator from "./RentalInstallmentCalculator/RentalInstallmentCalculator";
import LeasingOnlineInstallmentCalculator from "./LeasingOnlineInstallmentCalculator";
import InstallmentCalculatorTabs from "./InstallmentCalculatorTabs";

function InstallmentCalculatorStrategy(props) {

    const financialProduct = props.offer.financialProduct;

    if (financialProduct === FinancialProductType.RENTAL) {
        return <RentalInstallmentCalculator {...props} reservationStrategy={props.onShowOrderClick}/>;
    }

    return <InstallmentCalculatorTabs {...props}/>;
}

export default InstallmentCalculatorStrategy;
